/** Store types aligned with backend `StoreTypeEnum`. */
export const STORE_TYPE_OPTIONS = [
  { value: "KIRANA", label: "Kirana / general store" },
  { value: "SUPERMARKET", label: "Supermarket" },
  { value: "PHARMACY", label: "Pharmacy" },
  { value: "LIQUOR", label: "Liquor" },
  { value: "RESTAURANT", label: "Restaurant" },
  { value: "CAFE", label: "Café" },
  { value: "BAKERY", label: "Bakery" },
  { value: "CLOTHING", label: "Clothing" },
  { value: "ELECTRONICS", label: "Electronics" },
  { value: "SALON", label: "Salon" },
  { value: "SERVICE", label: "Service business" },
] as const;

export type StoreTypeValue = (typeof STORE_TYPE_OPTIONS)[number]["value"];

export function complianceHint(storeType: string | null): string | null {
  if (!storeType) return null;
  switch (storeType) {
    case "PHARMACY":
      return "Drug license number is required for pharmacies.";
    case "LIQUOR":
      return "Excise license number is required for liquor retail.";
    case "RESTAURANT":
    case "CAFE":
      return "FSSAI license number is required for food service.";
    default:
      return null;
  }
}
